
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PrestacionSaludProgramas extends Vue { 

    private planSaludPDF = `https://media.maipusalud.cl/media/documentos/2025/5/17465659971921.pdf`;
    
}
